var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "card border-0 bg-transparent",
      attrs: { id: "formAddTraining", action: "", method: "post" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.addTraining.apply(null, arguments)
        }
      }
    },
    [
      _c("section-headline", { attrs: { msg: _vm.headline } }),
      _vm._v(" "),
      _c("div", { staticClass: "row my-3 m" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "form-froup" }, [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.individualTraining,
                    expression: "individualTraining"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { id: "individualTraining", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.individualTraining)
                    ? _vm._i(_vm.individualTraining, null) > -1
                    : _vm.individualTraining
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.individualTraining,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.individualTraining = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.individualTraining = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.individualTraining = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "individualTraining" }
                },
                [_vm._v("Individuelles Training")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "form-group pb-0 mb-0" }, [
            _c("div", { staticClass: "form-row" }, [
              !this.individualTraining
                ? _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: [
                        this.formOptions.case === "merchant"
                          ? "col-md-12"
                          : "col-md-8"
                      ]
                    },
                    [
                      _c("label", [_vm._v("Training auswählen*")]),
                      _vm._v(" "),
                      _vm.isDataLoaded
                        ? _c("div", { staticClass: "multiselect" }, [_vm._m(0)])
                        : _c(
                            "div",
                            [
                              _c("multiselect", {
                                ref: "trainingSelect",
                                class: {
                                  "border border-danger": _vm.shouldAppendErrorClass(
                                    _vm.$v.form.trainingSelect
                                  ),
                                  "border border-success": _vm.shouldAppendValidClass(
                                    _vm.$v.form.trainingSelect
                                  )
                                },
                                attrs: {
                                  "clear-on-select": false,
                                  "close-on-select": false,
                                  "custom-label": _vm.numberWithName,
                                  multiple: true,
                                  "option-height": 90,
                                  options: _vm.form.trainingsOptions,
                                  searchable: true,
                                  deselectLabel: "",
                                  "group-label": "category",
                                  "group-values": "trainings",
                                  label: "name",
                                  placeholder: "Training auswählen",
                                  selectLabel: "",
                                  selectedLabel: "",
                                  "track-by": "name"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function(props) {
                                        return [
                                          props.option.$groupLabel
                                            ? _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "option__title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          props.option
                                                            .$groupLabel
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "option__desc d-flex flex-column"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "option__title mb-3"
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _c("u", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option
                                                                .trainings_number
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                props.option
                                                                  .name
                                                              )
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "option__description"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            props.option
                                                              .description
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3890832983
                                ),
                                model: {
                                  value: _vm.form.trainingsOptionValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "trainingsOptionValue",
                                      $$v
                                    )
                                  },
                                  expression: "form.trainingsOptionValue"
                                }
                              }),
                              _vm._v(" "),
                              _vm.$v.form.trainingSelect.$error
                                ? _c("small", { staticClass: "text-danger" }, [
                                    _vm._v("Bitte ein Training auswählen!")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.individualTraining
                ? _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: [
                        this.formOptions.case === "merchant"
                          ? "col-md-12"
                          : "col-md-8"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "trainingIndividual" } }, [
                        _vm._v("Individuelles Training:*")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.form.trainingIndividual.$model,
                            expression: "$v.form.trainingIndividual.$model",
                            modifiers: { lazy: true }
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "border border-danger": _vm.shouldAppendErrorClass(
                            _vm.$v.form.trainingIndividual
                          ),
                          "border border-success": _vm.shouldAppendValidClass(
                            _vm.$v.form.trainingIndividual
                          )
                        },
                        attrs: {
                          id: "trainingIndividual",
                          name: "trainingIndividual",
                          placeholder: "Individuelles Training"
                        },
                        domProps: {
                          value: _vm.$v.form.trainingIndividual.$model
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.$v.form.trainingIndividual,
                              "$model",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.$v.form.trainingIndividual.$error &&
                      _vm.$v.form.trainingIndividual.$dirty
                        ? _c("div", [
                            !_vm.$v.form.trainingIndividual.required
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    "Bitte einen Text\n                                eingeben."
                                  )
                                ])
                              : !_vm.$v.form.trainingIndividual.minLength
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    "Der Text muss mindestens 5\n                                Zeichen besitzen."
                                  )
                                ])
                              : !_vm.$v.form.trainingIndividual.maxLength
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    "Der Text darf nicht mehr als 50\n                                Zeichen besitzen."
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.formOptions.case === "employee"
                ? _c("div", { staticClass: "form-group col-md-4" }, [
                    _c("label", { attrs: { for: "trainingsNumber" } }, [
                      _vm._v("Personenanzahl")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.$v.form.trainingAttendeesNumber.$model,
                          expression: "$v.form.trainingAttendeesNumber.$model",
                          modifiers: { lazy: true }
                        }
                      ],
                      staticClass: "form-control min-height",
                      class: {
                        "border border-danger": _vm.shouldAppendErrorClass(
                          _vm.$v.form.trainingAttendeesNumber
                        ),
                        "border border-success": _vm.shouldAppendValidClass(
                          _vm.$v.form.trainingAttendeesNumber
                        )
                      },
                      attrs: { id: "trainingsNumber", type: "number" },
                      domProps: {
                        value: _vm.$v.form.trainingAttendeesNumber.$model
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(
                            _vm.$v.form.trainingAttendeesNumber,
                            "$model",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.form.trainingAttendeesNumber.$error
                      ? _c("div", [
                          !_vm.$v.form.trainingAttendeesNumber.required
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "Bitte die Personenanzahl\n                                angeben."
                                )
                              ])
                            : !_vm.$v.form.trainingAttendeesNumber.between
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "Die Zahl muss zwischen 1\n                                und 50 sein."
                                )
                              ])
                            : _vm.$v.form.trainingAttendeesNumber.integer
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "Bitte nur ganze Zahlen\n                                eingeben."
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-12 mb-0" }, [
                _c(
                  "label",
                  {
                    class: {
                      "text-danger": _vm.shouldAppendErrorClass(
                        _vm.$v.form.trainingComment
                      )
                    },
                    attrs: { for: "trainingComment" }
                  },
                  [
                    _vm._v("Kommentar: "),
                    this.form.trainingComment.length > 0
                      ? _c("small", [
                          _vm._v(
                            "(" +
                              _vm._s(this.form.trainingComment.length) +
                              " /\n                            150 Zeichen)"
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.form.trainingComment.$model,
                      expression: "$v.form.trainingComment.$model"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "border border-danger": _vm.shouldAppendErrorClass(
                      _vm.$v.form.trainingComment
                    ),
                    "border border-success": _vm.shouldAppendValidClass(
                      _vm.$v.form.trainingComment
                    )
                  },
                  attrs: {
                    id: "trainingComment",
                    cols: "30",
                    name: "trainingComment",
                    rows: "3"
                  },
                  domProps: { value: _vm.$v.form.trainingComment.$model },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.form.trainingComment,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.form.trainingComment.maxLength
                  ? _c("small", { staticClass: "text-danger" }, [
                      _vm._v(
                        "Es sind nicht mehr als 150 Zeichen\n                            erlaubt."
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-0 mt-md-2" }, [
        _c("div", { staticClass: "col d-flex justify-content-end" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success ",
              attrs: {
                disabled: _vm.$v.form.$invalid || this.sendingEmail,
                type: "submit"
              }
            },
            [
              !this.sendingEmail
                ? _c("i", { staticClass: "fas fa-plus mr-1" })
                : _vm._e(),
              _vm._v(" "),
              this.sendingEmail
                ? _c("i", { staticClass: "fa fa-spinner fa-spin fa-fw mr-1" })
                : _vm._e(),
              _vm._v("Hinzufügen\n            ")
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "multiselect__tags d-flex align-items-center p-1" },
      [
        _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x fa-fw mr-1" }),
        _vm._v(" "),
        _c("p", { staticClass: "m-0" }, [_vm._v("Trainings werden geladen!")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }